/**
 * custom-facets-core.js
 *
 * DOM-free matching logic for client-side faceted filtering.
 * Loaded before custom-facets.js in the browser (exposes window.CustomFacetsCore);
 * also require()-able in Node for unit tests (module.exports).
 *
 * Semantics: AND across different filters, OR within one filter's selected
 * values; ranges are inclusive numeric [gte, lte]; a product missing a value
 * for an active filter does not match. Mirrors Shopify's native filter semantics.
 */
(function (global) {
  var PREFIX = 'filter.p.m.custom.';

  function normalizeFacetValue(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function parseActiveFilters(searchParams, config) {
    var list = {};
    var range = {};
    (config || []).forEach(function (cf) {
      var param = PREFIX + cf.key;
      if (cf.type === 'range') {
        var gteRaw = searchParams.get(param + '.gte');
        var lteRaw = searchParams.get(param + '.lte');
        var hasGte = gteRaw !== null && gteRaw !== '';
        var hasLte = lteRaw !== null && lteRaw !== '';
        if (hasGte || hasLte) {
          range[cf.key] = {
            gte: hasGte ? parseFloat(gteRaw) : null,
            lte: hasLte ? parseFloat(lteRaw) : null,
          };
        }
      } else {
        var values = searchParams.getAll(param).filter(function (v) {
          return v !== '';
        });
        if (values.length) {
          list[cf.key] = new Set(values.map(normalizeFacetValue));
        }
      }
    });
    return { list: list, range: range };
  }

  function productMatchesFilters(productFacets, active) {
    var facets = productFacets || {};
    var key;

    for (key in active.list) {
      if (!Object.prototype.hasOwnProperty.call(active.list, key)) continue;
      var selected = active.list[key];
      var raw = facets[key];
      var candidates = Array.isArray(raw) ? raw : [raw];
      var normalized = candidates
        .filter(function (v) {
          return v !== null && v !== undefined && v !== '';
        })
        .map(normalizeFacetValue);
      var hit = normalized.some(function (v) {
        return selected.has(v);
      });
      if (!hit) return false;
    }

    for (key in active.range) {
      if (!Object.prototype.hasOwnProperty.call(active.range, key)) continue;
      var bound = active.range[key];
      var rawNum = facets[key];
      var num = typeof rawNum === 'number' ? rawNum : parseFloat(rawNum);
      if (isNaN(num)) return false;
      if (bound.gte !== null && num < bound.gte) return false;
      if (bound.lte !== null && num > bound.lte) return false;
    }

    return true;
  }

  function activeWithout(active, key) {
    var list = {};
    var range = {};
    for (var lk in active.list) {
      if (Object.prototype.hasOwnProperty.call(active.list, lk) && lk !== key) list[lk] = active.list[lk];
    }
    for (var rk in active.range) {
      if (Object.prototype.hasOwnProperty.call(active.range, rk) && rk !== key) range[rk] = active.range[rk];
    }
    return { list: list, range: range };
  }

  function computeFacetCounts(productsFacets, active, config) {
    var result = {};
    (config || []).forEach(function (cf) {
      if (cf.type === 'range') return;
      result[cf.key] = {};
    });
    (productsFacets || []).forEach(function (facets) {
      (config || []).forEach(function (cf) {
        if (cf.type === 'range') return;
        var others = activeWithout(active, cf.key);
        if (!productMatchesFilters(facets, others)) return;
        var raw = facets ? facets[cf.key] : undefined;
        var vals = Array.isArray(raw) ? raw : [raw];
        var seen = {};
        vals.forEach(function (v) {
          if (v === null || v === undefined || v === '') return;
          var nv = normalizeFacetValue(v);
          if (seen[nv]) return;
          seen[nv] = true;
          result[cf.key][nv] = (result[cf.key][nv] || 0) + 1;
        });
      });
    });
    return result;
  }

  var api = {
    normalizeFacetValue: normalizeFacetValue,
    parseActiveFilters: parseActiveFilters,
    productMatchesFilters: productMatchesFilters,
    computeFacetCounts: computeFacetCounts,
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  if (global) {
    global.CustomFacetsCore = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : this);
